import { render, staticRenderFns } from "./moveDialog.vue?vue&type=template&id=3a5f3b8a&scoped=true"
import script from "./moveDialog.vue?vue&type=script&lang=js"
export * from "./moveDialog.vue?vue&type=script&lang=js"
import style0 from "./moveDialog.vue?vue&type=style&index=0&id=3a5f3b8a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5f3b8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a5f3b8a')) {
      api.createRecord('3a5f3b8a', component.options)
    } else {
      api.reload('3a5f3b8a', component.options)
    }
    module.hot.accept("./moveDialog.vue?vue&type=template&id=3a5f3b8a&scoped=true", function () {
      api.rerender('3a5f3b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/cloudfile/components/moveDialog.vue"
export default component.exports